<template>
  <v-app id="forgot-password">
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4>

            <v-card class="elevation-1 pa-5">

              <v-card-text>

                <h3>Reset Password</h3>
                <p>Please enter the email address you used when creating your account.</p>

                <v-form id="forgot-password-form" @submit.prevent="login">
                  <v-text-field v-model="email" name="login" label="Email" type="text"></v-text-field>
                </v-form>

                <div class="login-error" v-if="hasError">
                  {{ errorMessage }}
                </div>

              </v-card-text>
              <v-card-actions>
                <v-btn :to="{ name: 'login' }" text type="submit" color="black">← Go back to sign-in</v-btn>
                <v-spacer></v-spacer>
                <v-btn @click="resetPassword" text :disabled="loading" :loading="loading" type="submit" color="primary">Send Reset Email</v-btn>
              </v-card-actions>
            </v-card>

          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>

  export default {
    components: {},
    data () {
      return { email: '', loading: false }
    },
    methods: {
      resetPassword () {
        this.loading = true
      }
    }
  }

</script>
